





















import Vue from "vue";
import LoginCard from "@/components/LoginCard.vue";
import SignWithEmailLinkLandingCard from "@/components/SignWithEmailLinkLandingCard.vue";
import Separator from "@/components/Separator.vue";
import config from "@/configs";

export default Vue.extend({
  name: "LoginPage",
  components: {
    Separator,
    LoginCard,
    SignWithEmailLinkLandingCard,
  },
  data() {
    return {
      hasOtherLoginProviders: false,
      failedEmailSignIn: false,
      company: config?.settings.company,
    };
  },
  computed: {
    isFromEmailLink(): boolean {
      return !!this.$route.query.emailLogin;
    },
    showEmailLinkLogin(): boolean {
      return this.isFromEmailLink && !this.failedEmailSignIn;
    },
  },
});
